<template>
	<div>
		<h1>Добавление новости</h1>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
			<el-form-item label="Заголовок" prop="title">
				<el-input v-model="ruleForm.title"></el-input>
			</el-form-item>
			<el-form-item label="Ссылка на источник">
				<el-input v-model="ruleForm.url"></el-input>
			</el-form-item>
			<el-form-item prop="text" class="form-html">
				<textarea id="editornew" multiple ref="editornew" name="editor"></textarea>
			</el-form-item>
			<div class="line-border"></div>
			<div class="Small Title m-b-20">Список прикрепленных файлов</div>
			<div>
				<addFileNew 
					ref="fileListLoad"
					:fileList="fileList"
					@addFile="addFile"
					@removeNewFile="removeNewFile"
				/>
			</div>
			<div class="line-border"></div>
			<el-form-item class="m-t-20">
				<el-button @click="backRoute()">Назад</el-button>
				<el-button type="primary" @click="submitForm()" :loading="loadingSub">Сохранить</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
import { BASE_URL, BASE_DOC_URL } from '@/plugins/url-env'
import addFileNew from './addFileToNews'

export default {
	data() {
		return {
			loadingSub: false,
            fileList: {
                files: []
            },
			ruleForm: {
				title: "",
				url: "",
				shortText: "",
				text: "",
				files: []
			},
			rules: {
				shortText: [
					{
						required: true,
						message: "Поле не должно быть пустым",
						trigger: "blur"
					},
					{
						min: 0,
						max: 200,
						message: "Максимум 200 символов",
						trigger: "blur"
					}
				],
				text: [{
						required: true,
						message: "Поле не должно быть пустым",
						trigger: "blur"
					},
					{
						min: 0,
						max: 100000,
						message: "Максимум 100000 символов",
						trigger: "blur"
					}
				],
				title: [{
						required: true,
						message: "Поле не должно быть пустым",
						trigger: "blur"
					},
					{
						min: 0,
						max: 100,
						message: "Максимум 100 символов",
						trigger: "blur"
					}
				]
			}
		};
	},
	mounted() {
		this.initializationEditor();
	},
	methods: {
		addFile(data) {
			let img = new Image();
			img.src = URL.createObjectURL(data.file.raw);
			data.file.image = img;
			
			this.fileList.files.push({
				title: data.title,
				file: data.file
			})
		},
		removeNewFile(index) {
			this.fileList.files.splice(index, 1)
		},
		async initializationEditor() {
			setTimeout(() => {
				let editor = new Jodit(this.$refs.editornew, {
					uploader: {
						url: BASE_URL + "/LocalStorage/Upload",
						format: "json",
						filesVariableName: "File",
						pathVariableName: "File",
						withCredentials: true,
						prepareData: function (data) {
							data.append("file", data.get("files[0]"));
							data.delete('files[0]')
							data.delete('path')
							data.delete('source')
						},
						isSuccess: function (resp) {
							if (window.getSelection) {
								var elem = document.createElement("img");
								const src = `${BASE_URL}/${resp.file}`;
								elem.src = src;
								var wall = window.getSelection().focusNode.parentNode.firstChild.parentNode;
								//проверяем где расположена каретка. Если вне редактора тогда вставляем картинку начало
								if (window.getSelection().focusNode.parentNode.firstChild.parentNode.closest(".jodit_wysiwyg") !== null) {
									var first = wall.childNodes[0];
									wall.insertBefore(elem, first);
								} else {
									editor.value = `<img src="${src}" />` + editor.value;
								}
							} else if (document.selection && document.selection.createRange) {
								document.selection.createRange().text = respImg;
							}

							return !resp.error;
						},
						getMsg: function (resp) {
							return resp.msg.join !== undefined ?
								resp.msg.join(" ") :
								resp.msg;
						},
						process: function (resp) {
							return {
								baseurl: resp.baseurl,
                error: resp.error,
                msg: resp.msg
							};
						},
						error: function (e) {
							this.$notify.error({
								title: "Произошла ошибка",
								message: `Что-то пошло не так, обратитесь в техподдержку`,
								offset: 0
							});
						},
						defaultHandlerSuccess: function (data, resp) {
							var i,
								field = "files";
							if (data[field] && data[field].length) {
								for (i = 0; i < data[field].length; i += 1) {
									this.selection.insertImage(data.baseurl + data[field][i]);
								}
							}
						},

						defaultHandlerError: function (resp) {
              console.log("err => ", resp);
						}
					},
					language: "ru",
					minHeight: 400,
					editSrc: true,
					showPreview: true
				});
				editor.value = this.ruleForm.text;

				editor.events.on("change", data => {
					this.ruleForm.text = data;
				});
			}, 400);
		},
		async submitForm() {
			let validateFileList = await this.$refs.fileListLoad.validateFilesName()

			this.$refs.ruleForm.validate(async valid => {
				if (valid && validateFileList) {
					
					let loading = this.$loading({
						lock: true,
						text: 'Подождите',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});

					try {

						for(let item of  this.fileList.files) {
							if(!item.fileName) {
								let data = new FormData()
								data.append('IsAttachment', true)
								data.append("file",item.file.raw);
								data.append("title",  item.title)

								let query = await this.$store.dispatch('documentUploadFile', data)
								item.fileName = query
								this.ruleForm.files.push(query.fileName)
							}
						}

						await this.$store.dispatch("newsCreate", this.ruleForm);

						this.$message({
							message: "Новость добавлена",
							type: "success"
						});
						setTimeout(() => {
							this.$router.push({
								path: "/news/"
							});
						}, 1000);
						
					} catch (e) {
						this.$ErrorsMod(e);
					}

					loading.close();    
				} else {
					return false;
				}
			});
		},

		backRoute() {
			this.$router.push({
				path: "/news/"
			});
		}
	},
	components: {
		addFileNew
	}
};
</script>
<style>
	.line-border {
		border-bottom: 1px solid #ccc;
		margin: 30px 0 20px 0;
		width: 100%;
	}
	.el-upload-item_list-block {
		background-color: #fff;
		border: 1px solid#c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		width: 38px;
		height: 38px;
		margin: 0 8px 8px 0;
		display: block;
		position: relative;
	}
	.el-upload-item_list-block-actions:hover {
		opacity: 1;
	}
	.el-upload-item_list-block-actions {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		cursor: default;
		text-align: center;
		color: #fff;
		opacity: 0;
		font-size: 20px;
		background-color: rgba(0, 0, 0, 0.5);
		transition: opacity 0.3s;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.el-upload-list__item-preview {
		cursor: pointer;
	}
	.el-upload-list_right-form {
		width: 100%;
	}
	.el-upload-list_right-form span {
		color: #b5b5b5;
		font-size: 12px;
	}
	.el-upload-list-item-file {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		color: #949ba4;
	}
	.el-upload-list-item-file .el-icon-document {
		font-size: 16px;
	}
</style>
